// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__16q5s","content":"styles_content__21PDG","intro":"styles_intro__3XDpp"};